export default __webpack_public_path__ + "static/media/sm_green_bot.8430f9d5.gif";